<template>
	<div>
		<!-- definePageMeta -->
		<Head>
			<Title>{{ pageMetaObject?.title ?? `${$t('common.contact_page')} | CarFree` }}</Title>
			<Meta name="description" :content="pageMetaObject?.description ?? ''" />
			<Meta v-if="config.public.environment === 'production-to-change' && robotsCalculated" name="robots" :content="robotsCalculated ?? ''" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Link rel="canonical" :href="pageMetaObject?.canonical && pageMetaObject?.canonical?.trim() ? pageMetaObject?.canonical : url.href" />
		</Head>

		<GlobalHeader />
		<ContactPageHero />
		<LazyVisibleContactPageCompany hydrate-on-visible />
		<LazyVisibleContactPageHelp hydrate-on-visible />
		<div class="contact-page__departments">
			<LazyVisibleGlobalDepartmentsSection :title="$t('pages.contact.contact_the_branch')" :contact="true" hydrate-on-visible />
		</div>
		<LazyVisibleContactPageQuestions :pageSection="pageFaqSection" hydrate-on-visible />
		<LazyVisibleGlobalFooter hydrate-on-visible />
	</div>
</template>

<script setup lang="ts">
import { ECMSType, ECMSPage, EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const config = useNuxtApp().$config
const pageSections = ref<IHomePageSectionModel[]>()
const pageFaqSection = ref<ICMSLocationContent>()
const pageMetaObject = ref<{ [key: string]: string } | undefined>()
const { locale } = useI18n()
provide('pageSections', pageSections)
const url = useRequestURL()
const getContactPageSections = async () => {
	try {
		pageSections.value = (await ApiService.fetchPageSections(ECMSType.SUBPAGE, ECMSPage.CONTACT, locale.value))?.data
		pageMetaObject.value = pageSections.value
			?.find((section) => section.name === EPageSectionType.META)
			?.translations.find((translation) => translation.language === locale.value)?.content[0]
		pageFaqSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.FAQ)
	} catch (error) {
		console.log(error)
	}
}

await getContactPageSections()

const robotsCalculated = computed(() => {
	if (!pageMetaObject.value?.robots || pageMetaObject.value?.robots?.length === 0) return undefined
	return pageMetaObject.value?.robots.join(', ')
})

const sendAnalyticsData = () => {
	const gtmService = useGTMService()
	if (!gtmService) return
	gtmService.pageViewed({ page_type: 'contact' })
}

if (process.client) sendAnalyticsData()
</script>
<style lang="scss" scoped>
.contact-page__departments {
	margin-bottom: 64px;
}
</style>
